import { render, staticRenderFns } from "./ShareSeparatePercentages.vue?vue&type=template&id=d7fcdc30"
import script from "./ShareSeparatePercentages.vue?vue&type=script&lang=js"
export * from "./ShareSeparatePercentages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports